import { render } from "./ad-carousel.vue?vue&type=template&id=abe8d804&lang=pug"
import script from "./ad-carousel.vue?vue&type=script&lang=js"
export * from "./ad-carousel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__